import { useIntl } from 'react-intl';

import useAuth from 'src/hooks/useAuth';

import { formatWeight, hasValue } from '../utils';

function BowTieControlMetadata({ control }) {
  const intl = useIntl();
  const { decimalSeparator, thousandsSeparator } = useAuth();
  const effectiveness = control?.ultimaEfetividade;
  const hasWeight = hasValue(control?.peso);
  const hasEffectiveness = hasValue(effectiveness);

  if (!hasWeight && !hasEffectiveness) return null;

  return (
    <span className="tw:mt-1.5 tw:flex tw:flex-wrap tw:gap-1.25">
      {hasWeight && (
        <span className="tw:max-w-full tw:truncate tw:rounded-lg tw:bg-[#edf1f5] tw:px-1.5 tw:py-0.5 tw:text-[10px]/[1.2] tw:text-[#60717d]">
          {`${intl.formatMessage({ id: 'peso' })}: ${formatWeight(
            control.peso,
            decimalSeparator,
            thousandsSeparator
          )}%`}
        </span>
      )}
      {hasEffectiveness && (
        <span className="tw:max-w-full tw:truncate tw:rounded-lg tw:bg-[#edf1f5] tw:px-1.5 tw:py-0.5 tw:text-[10px]/[1.2] tw:text-[#60717d]">
          {`${intl.formatMessage({
            id: 'label.efetividade',
          })}: ${effectiveness}`}
        </span>
      )}
    </span>
  );
}

export default BowTieControlMetadata;
